export class Address {
  constructor(options) {
    Object.assign(this, options);
  }
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
}
